import { createSlice } from "@reduxjs/toolkit";

const LENDER_CLOSING_REASONS_SLICE_NAME = "lenderCallLogLenderClosingReasons";

const initialState = {
  lenderClosingReasons: [],
};

const lenderClosingReasonsSlice = createSlice({
  name: LENDER_CLOSING_REASONS_SLICE_NAME,
  initialState,
  reducers: {
    populateLenderClosingReasons(state, action) {
      state.lenderClosingReasons = action.payload;
    },
  },
});

export const { populateLenderClosingReasons } = lenderClosingReasonsSlice.actions;

export default lenderClosingReasonsSlice.reducer;
